export default __webpack_public_path__ + "navigation-examples-custom-waypoint-960-33f4dacd09a79192de05ddd89db69abc.png";